import CommunityFeed from "@/pages/CommunityFeed";

import { AppSection } from "../../ui-foundation";

const Kinfeed = () => (
  <AppSection>
    <CommunityFeed />
  </AppSection>
);

export default Kinfeed;
